export default "__VITE_ASSET__f445b256__"